export var Page;
(function (Page) {
    Page["Voip"] = "voip";
    Page["OtherContacts"] = "otherContacts";
})(Page || (Page = {}));
